module.exports = __webpack_public_path__ + "img/bbva-dark.cfe5c11c.png";